import Eyebrow from '@Guidelines/Component/Eyebrow';
import GridCard from '@Guidelines/Component/GridCard';
import ConditionalLoader from '@Guidelines/Component/Loader/ConditionalLoader';
import { reveal } from '@Guidelines/Theme/helpers/animations';
import { theme } from '@Guidelines/Theme/theme';
import { css } from '@emotion/react';
import { UploadCloud } from 'lucide-react';
import type * as React from 'react';

const headerStyle = css`
	display: flex;
	align-items: center;
	gap: 0.875rem;
`;

const tileStyle = css`
	flex: none;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 2.75rem;
	height: 2.75rem;
	border-radius: ${theme.radii.medium};
	background-color: ${theme.colors.accentSurface};
	color: ${theme.colors.accentDark};
`;

const titleStyle = css`
	${theme.typography.cardTitle}
	margin: 0.25rem 0 0;
	color: ${theme.colors.ink};
`;

const detailStyle = css`
	margin: 0;
	font-family: ${theme.fonts.body};
	font-size: ${theme.fontSizes.large};
	color: ${theme.colors.inkSecondary};
`;

const footnoteStyle = css`
	margin: 0;
	font-family: ${theme.fonts.body};
	font-size: ${theme.fontSizes.small};
	color: ${theme.colors.inkMuted};
`;

type Props = {
	readonly title: string;
	readonly detail: string;
	readonly footnote: string | null;
	/** Rendered between the detail and the footnote: progress, failure, actions. */
	readonly children?: React.ReactNode;
};

/** The frame both transfer cards share: icon tile, title, help text, then whatever the status adds. */
const TransferCardShell: React.FC<Props> = ({ title, detail, footnote, children }) => {
	return (
		<GridCard layout="stacked" rowGap="1rem" css={reveal(0)}>
			<div css={headerStyle}>
				<span css={tileStyle}>
					<UploadCloud size={22} aria-hidden="true" />
				</span>
				<div>
					<Eyebrow>Transfert de l'enregistrement</Eyebrow>
					<h2 css={titleStyle}>{title}</h2>
				</div>
			</div>
			<p css={detailStyle}>{detail}</p>
			{children}
			<ConditionalLoader data={footnote}>
				{(text) => <p css={footnoteStyle}>{text}</p>}
			</ConditionalLoader>
		</GridCard>
	);
};

export default TransferCardShell;
